var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 15.1738C6.75 14.7596 6.41421 14.4238 6 14.4238C5.58579 14.4238 5.25 14.7596 5.25 15.1738H6.75ZM5.25 7.17383C5.25 7.58804 5.58579 7.92383 6 7.92383C6.41421 7.92383 6.75 7.58804 6.75 7.17383H5.25ZM10 1.92383H15V0.423828H10V1.92383ZM18.25 5.17383V17.1738H19.75V5.17383H18.25ZM15 20.4238H10V21.9238H15V20.4238ZM6.75 17.1738V15.1738H5.25V17.1738H6.75ZM6.75 7.17383V5.17383H5.25V7.17383H6.75ZM10 20.4238C8.20507 20.4238 6.75 18.9688 6.75 17.1738H5.25C5.25 19.7972 7.37665 21.9238 10 21.9238V20.4238ZM18.25 17.1738C18.25 18.9688 16.7949 20.4238 15 20.4238V21.9238C17.6234 21.9238 19.75 19.7972 19.75 17.1738H18.25ZM15 1.92383C16.7949 1.92383 18.25 3.3789 18.25 5.17383H19.75C19.75 2.55048 17.6234 0.423828 15 0.423828V1.92383ZM10 0.423828C7.37665 0.423828 5.25 2.55048 5.25 5.17383H6.75C6.75 3.3789 8.20507 1.92383 10 1.92383V0.423828Z",
    fill: "#ED1C00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 14.1738L13.2929 11.8809C13.6834 11.4904 13.6834 10.8572 13.2929 10.4667L11 8.17383",
    stroke: "#ED1C00",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 11.1738L1 11.1738",
    stroke: "#ED1C00",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.4f530f48fbf8054112e855be7e7ee853.svg";
export { ForwardRef as ReactComponent };